import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProjectSettingsAttachmentsViewTopBar } from "./TopBar"

export const projectSettingsAttachmentViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProjectSettingsAttachmentsViewTopBar,
}
